import React from "react";
import PageTitle from "../components/pagetitle/PageTitle";
import Footer from "../components/footer/Footer";
import Sidebar from "../components/sidebar/Sidebar";
import { Link } from "react-router-dom";

import img1 from "../assets/images/layouts/blog-detail.png";
import avt1 from "../assets/images/layouts/avt-01.png";
import avt2 from "../assets/images/layouts/avt-02.png";
import avt3 from "../assets/images/layouts/avt-03.png";
import avt4 from "../assets/images/layouts/avt-04.png";

function PrivacyPolicy(props) {
  return (
    <div className="wrapper">
      <PageTitle title="Privacy Policy" />

      <section className="bloglist">
        <div className="container">
          <div className="row">
            <div className="bloglist__main">
              <div className="list details">
                {/* <h4 className="title">Privacy Policy</h4> */}

                {/* <div className="line"></div> */}

                <div className="content-d">
                  <ul className="list-social">
                    <li>
                      <Link to="#">
                        <svg
                          width="9"
                          height="16"
                          viewBox="0 0 9 16"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M2.57969 9.03953C2.51969 9.03953 1.19969 9.03953 0.599688 9.03953C0.279688 9.03953 0.179688 8.91953 0.179688 8.61953C0.179688 7.81953 0.179688 6.99953 0.179688 6.19953C0.179688 5.87953 0.299688 5.77953 0.599688 5.77953H2.57969C2.57969 5.71953 2.57969 4.55953 2.57969 4.01953C2.57969 3.21953 2.71969 2.45953 3.11969 1.75953C3.53969 1.03953 4.13969 0.559531 4.89969 0.279531C5.39969 0.0995311 5.89969 0.0195312 6.43969 0.0195312H8.39969C8.67969 0.0195312 8.79969 0.139531 8.79969 0.419531V2.69953C8.79969 2.97953 8.67969 3.09953 8.39969 3.09953C7.85969 3.09953 7.31969 3.09953 6.77969 3.11953C6.23969 3.11953 5.95969 3.37953 5.95969 3.93953C5.93969 4.53953 5.95969 5.11953 5.95969 5.73953H8.27969C8.59969 5.73953 8.71969 5.85953 8.71969 6.17953V8.59953C8.71969 8.91953 8.61969 9.01953 8.27969 9.01953C7.55969 9.01953 6.01969 9.01953 5.95969 9.01953V15.5395C5.95969 15.8795 5.85969 15.9995 5.49969 15.9995C4.65969 15.9995 3.83969 15.9995 2.99969 15.9995C2.69969 15.9995 2.57969 15.8795 2.57969 15.5795C2.57969 13.4795 2.57969 9.09953 2.57969 9.03953Z"
                            fill="white"
                          ></path>
                        </svg>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <svg
                          width="15"
                          height="12"
                          viewBox="0 0 15 12"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.5 1.42062C13.9794 1.66154 13.4246 1.82123 12.8462 1.89877C13.4412 1.524 13.8954 0.935077 14.1089 0.225231C13.5541 0.574154 12.9416 0.820615 12.2889 0.958154C11.7621 0.366462 11.0114 0 10.1924 0C8.60337 0 7.32412 1.36062 7.32412 3.02862C7.32412 3.26862 7.34338 3.49938 7.39062 3.71908C5.0045 3.59631 2.89313 2.38985 1.47475 0.552C1.22712 1.00523 1.08188 1.524 1.08188 2.08246C1.08188 3.13108 1.59375 4.06062 2.35675 4.59877C1.89562 4.58954 1.44325 4.44831 1.06 4.22585C1.06 4.23508 1.06 4.24708 1.06 4.25908C1.06 5.73046 2.05487 6.95262 3.3595 7.23415C3.12587 7.30154 2.87125 7.33385 2.607 7.33385C2.42325 7.33385 2.23775 7.32277 2.06362 7.28215C2.4355 8.48123 3.49075 9.36277 4.7455 9.39138C3.769 10.1972 2.52912 10.6828 1.18688 10.6828C0.9515 10.6828 0.72575 10.6717 0.5 10.6412C1.77137 11.5062 3.27813 12 4.903 12C10.1845 12 13.072 7.38462 13.072 3.384C13.072 3.25015 13.0676 3.12092 13.0615 2.99262C13.6311 2.56615 14.1097 2.03354 14.5 1.42062Z"
                            fill="white"
                          ></path>
                        </svg>
                      </Link>
                    </li>
                    <li>
                      <Link to="#">
                        <svg
                          width="14"
                          height="14"
                          viewBox="0 0 14 14"
                          fill="none"
                          xmlns="http://www.w3.org/2000/svg"
                        >
                          <path
                            d="M14.0006 14V8.87249C14.0006 6.35249 13.4581 4.42749 10.5181 4.42749C9.10062 4.42749 8.15563 5.19749 7.77063 5.93249H7.73563V4.65499H4.95312V14H7.85813V9.36249C7.85813 8.13749 8.08563 6.96499 9.59063 6.96499C11.0781 6.96499 11.0956 8.34749 11.0956 9.43249V13.9825H14.0006V14Z"
                            fill="white"
                          ></path>
                          <path
                            d="M0.226562 4.65479H3.13156V13.9998H0.226562V4.65479Z"
                            fill="white"
                          ></path>
                          <path
                            d="M1.68 0C0.7525 0 0 0.7525 0 1.68C0 2.6075 0.7525 3.3775 1.68 3.3775C2.6075 3.3775 3.36 2.6075 3.36 1.68C3.36 0.7525 2.6075 0 1.68 0Z"
                            fill="white"
                          ></path>
                        </svg>
                      </Link>
                    </li>
                  </ul>

                  <div className="main">
                    <p>
                      At GMGN (&ldquo;GMGN,&rdquo; &ldquo;we,&rdquo; or
                      &ldquo;our&rdquo;), safeguarding your privacy is a top
                      priority. This Privacy Policy (the &ldquo;Policy&rdquo;)
                      outlines how we collect, use, and disclose your Personal
                      Information (as defined below). It should be read together
                      with our Terms of Service (&ldquo;Terms&rdquo;), which are
                      incorporated by reference into this Policy.
                    </p>

                    <p>
                      Please note that we reserve the right to modify our
                      policies and practices at any time. The latest version of
                      this Policy will always be available on this page.
                      Continued use of our Platform after any changes indicates
                      your acceptance of those changes. We recommend checking
                      this Policy regularly for updates.
                    </p>

                    <h6>This Policy Details:</h6>

                    <p>
                      The types of information we collect from you or that you
                      provide when you visit our website at{" "}
                      <a data-fr-linked="true" href="https://GMGN.io">
                        https://GMGN.io
                      </a>{" "}
                      or use any related tools, mobile applications, web
                      applications, decentralized applications, smart contracts,
                      or Application Programming Interfaces (&ldquo;APIs&rdquo;)
                      available on any GMGN website, including any successor
                      sites or applications (collectively, the
                      &ldquo;Platform&rdquo;).
                    </p>

                    <p>
                      Our methods for collecting, using, storing, safeguarding,
                      and disclosing that information.
                    </p>

                    <p>
                      Please review this Policy carefully to understand our
                      practices and how we handle your personal information. If
                      you disagree with our policies and practices, do not
                      continue to use our Platform. By using our Platform, you
                      agree to the terms of this Policy.
                    </p>

                    <h5>PERSONAL INFORMATION WE COLLECT</h5>

                    <p>
                      &quot;Personal Information&quot; refers to data that
                      directly or indirectly identifies or can reasonably
                      identify an individual, or information that can be
                      associated with an identified or identifiable person.
                    </p>

                    <p>Information Collected Directly from You:</p>
                    <p>
                      We (or our affiliates) may collect the following types of
                      Personal Information directly from you:
                    </p>

                    <p>
                      Identifying Details: Your name, email address, phone
                      number, postal address, wallet address, and any
                      information legally required, such as data needed for Know
                      Your Customer (KYC) verification.
                    </p>

                    <p>Information Collected Automatically:</p>
                    <p>
                      We (or our affiliates) may automatically gather the
                      following types of Personal Information during your use of
                      our services:
                    </p>

                    <p>
                      IP Address and Domain Information: Your IP address and
                      domain name.
                    </p>

                    <p>
                      Device and System Information: Details about your device,
                      including its operating system, browser type, device name,
                      and language preferences.
                    </p>

                    <p>
                      Usage Data: Information on your interactions with our
                      Platform, including system activity and the pages you
                      visit on our website.
                    </p>

                    <p>
                      Geolocation Data: Information about the location of your
                      device.
                    </p>

                    <p>
                      Automatic data collection may involve the use of cookies,
                      which are detailed further below. While GMGN does not
                      store online identifiers, device information, or
                      geolocation data directly, third parties we engage with,
                      such as vendors or payment processors, may retain such
                      information.
                    </p>

                    <p>Information Collected from Third Parties:</p>
                    <p>
                      We may also collect or verify the following categories of
                      Personal Information about you from third parties:
                    </p>

                    <p>
                      Identification Information: Your name, email address,
                      phone number, and postal address.
                    </p>

                    <p>Transaction Information:</p>
                    <p>
                      We may collect information related to blockchain
                      transactions, such as data visible on public blockchains.
                      In certain cases, if we or others can associate your
                      public digital asset address with other Personal
                      Information, it may be possible to identify you through
                      blockchain transactions. This is because personal
                      information published on a blockchain, such as your
                      digital asset address and IP address, can sometimes be
                      linked with other data we or third parties may possess.
                      Additionally, advanced data analysis techniques applied to
                      blockchain data might reveal other Personal Information
                      about you. We may also collect additional information as
                      needed to fulfill legal requirements.
                    </p>

                    <h5>Accuracy and Retention of Personal Information</h5>
                    <p>
                      We are committed to ensuring that your Personal
                      Information is accurate and up-to-date for the purposes
                      for which it is used. We will not retain your Personal
                      Information for longer than necessary to fulfill those
                      purposes.
                    </p>

                    <h5>MINOR PERSONAL INFORMATION</h5>
                    <p>
                      We do not knowingly collect or market data to individuals
                      under the age of 18. By using our Platform, you confirm
                      that you are at least 18 years old or that you have the
                      consent of a parent or guardian if you are under 18. If we
                      discover that we have collected Personal Information from
                      individuals under 18, we will take immediate action to
                      deactivate the account and remove the data from our
                      records. If you believe we have collected information from
                      a minor, please contact us.
                    </p>

                    <h5>HOW WE USE YOUR PERSONAL INFORMATION</h5>
                    <p>
                      We gather and use your Personal Information to enhance
                      your experience, safeguard against risks, and improve our
                      Services. Specifically, we may use your Personal
                      Information for the following purposes:
                    </p>

                    <p>
                      To Deliver Our Services: We use your Personal Information
                      to deliver our Services as outlined in our Terms of
                      Service.
                    </p>

                    <p>
                      To Comply with Legal and Regulatory Obligations: We
                      process your Personal Information to adhere to applicable
                      laws and regulations.
                    </p>

                    <p>
                      To Detect and Prevent Fraud: We utilize your Personal
                      Information to identify and prevent fraudulent activities.
                    </p>

                    <p>
                      To Ensure the Security and Integrity of Our Services: We
                      use your Personal Information, including device
                      information and activity on GMGN, to protect the security
                      of your account and our platform.
                    </p>

                    <p>
                      To Provide Customer Support: We process your Personal
                      Information when you reach out to our support team for
                      assistance or to resolve technical issues.
                    </p>

                    <p>
                      To Market Our Products: With your consent, we may contact
                      you with information about our Services. You can opt out
                      of these communications at any time.
                    </p>

                    <h5>HOW WE SHARE YOUR PERSONAL INFORMATION</h5>
                    <p>
                      We are committed to protecting your Personal Information
                      and will not sell, share, or rent it to third parties for
                      commercial purposes. However, we may disclose your
                      Personal Information in the following circumstances:
                    </p>

                    <p>
                      Service Providers: We may share your Personal Information
                      with trusted third-party service providers who assist us
                      with business operations such as fraud detection, security
                      threat assessment, payment processing, customer support,
                      data analytics, IT services, advertising, marketing,
                      network infrastructure, storage, and transaction
                      monitoring. These providers are only permitted to use your
                      Personal Information to deliver their services to us and
                      are prohibited from using or disclosing it for any other
                      purposes.
                    </p>

                    <p>
                      Law Enforcement: We may be required to disclose your
                      Personal Information to law enforcement agencies,
                      government officials, or regulatory bodies if mandated by
                      law or regulation.
                    </p>

                    <p>
                      With Your Consent: We may share your Personal Information
                      if you have given us explicit consent to do so.
                    </p>

                    <p>
                      If we make changes to the purposes for which your Personal
                      Information is collected and used, we will update this
                      Policy accordingly.
                    </p>

                    <h5>COOKIES</h5>
                    <p>
                      When you access GMGN, we may use various tracking
                      technologies, including cookies, flash cookies, pixel
                      tags, and other similar tools (collectively referred to as
                      &quot;Cookies&quot;). Cookies help us recognize you as a
                      user, gather data on your interactions with GMGN, and
                      tailor our services and content to enhance your
                      experience. Specifically, Cookies are used to:
                    </p>

                    <p>
                      (i) Monitor Account Security: Detect irregular or
                      potentially fraudulent activities to ensure the safety of
                      your account.
                    </p>

                    <p>
                      (ii) Improve Services: Evaluate and refine our services
                      and advertising efforts based on your usage patterns.
                    </p>

                    <p>
                      Please be aware that rejecting Cookies may affect your
                      ability to use certain features or pages on GMGN. If you
                      do not agree to the use of Cookies, please refrain from
                      visiting or using GMGN.
                    </p>

                    <h5>DIRECT MARKETING</h5>
                    <p>
                      In accordance with applicable laws and regulations, we may
                      occasionally send you marketing materials about our
                      services, products, or other offerings based on the
                      information we have collected. You have the option to opt
                      out of these communications at any time by following the
                      unsubscribe instructions provided in each marketing
                      message. We do not share your Personal Information with
                      third parties for their direct marketing purposes without
                      your explicit consent.
                    </p>

                    <h5>INFORMATION SECURITY</h5>
                    <p>
                      At GMGN, we are committed to safeguarding your Personal
                      Information, although we cannot guarantee complete
                      security. We implement a range of measures to protect
                      against unauthorized access, alteration, disclosure, or
                      destruction of the Personal Information we collect and
                      store. These measures include:
                    </p>

                    <p>
                      Encryption: We use SSL to encrypt communications between
                      our website and your device.
                    </p>

                    <p>
                      Regular Reviews: We periodically assess our practices for
                      collecting, storing, and processing Personal Information.
                    </p>

                    <p>
                      Access Control: Access to Personal Information is
                      restricted to authorized employees only.
                    </p>

                    <h5>
                      INFORMATION FOR PERSONS SUBJECT TO EU DATA PROTECTION LAW
                    </h5>
                    <p>
                      For customers located in the European Union (EU), European
                      Economic Area (EEA), Channel Islands, or other regions
                      covered by EU data protection laws (collectively,
                      &quot;Europe&quot;), we acknowledge our obligations under
                      the General Data Protection Regulation (EU) 2016/679
                      (&quot;GDPR&quot;). In this context, &quot;personal
                      data&quot; refers to the definition provided in the GDPR.
                    </p>

                    <p>Legal Bases for Processing</p>

                    <p>
                      Under GDPR, we process personal data based on one or more
                      of the following legal grounds:
                    </p>

                    <p>
                      Legal Obligation: To carry out anti-fraud activities and
                      comply with retention and other legal requirements.
                    </p>

                    <p>
                      Contractual Obligation: To fulfill our commitments under
                      our Terms of Service, including providing services and
                      customer support.
                    </p>

                    <p>
                      Legitimate Interest: To monitor and enhance the usage of
                      GMGN, conduct security checks, and protect our rights.
                    </p>

                    <p>
                      Consent: To market GMGN and our services. You may withdraw
                      your consent at any time, which will not affect the
                      legality of processing conducted before your withdrawal.
                    </p>

                    <h6>European Privacy Rights</h6>

                    <p>
                      European residents have the following rights regarding
                      their personal data under GDPR, subject to applicable
                      legal exceptions:
                    </p>

                    <p>
                      Right to Access and Rectification: You can request that
                      GMGN disclose the personal data we hold about you and
                      correct any inaccuracies.
                    </p>

                    <p>
                      Right to Erasure: You can request that we delete your
                      personal data.
                    </p>

                    <p>
                      Right to Restriction of Processing: You have the right to
                      restrict or object to the processing of your personal data
                      in certain situations.
                    </p>

                    <p>
                      Right to Data Portability: You have the right to receive
                      your personal data in an electronic format and transfer it
                      to another data controller.
                    </p>

                    <p>
                      To exercise these rights, please contact us using the
                      methods outlined at the end of this Policy. When
                      processing such requests, we will verify the identity of
                      the requester to ensure they are authorized to make the
                      request.
                    </p>

                    <h5>COLLECTION AND TRANSFER OF DATA OUTSIDE THE EEA</h5>
                    <p>
                      GMGN operates with many of our systems all around the
                      world. Consequently, we may transfer personal data from
                      Europe to countries outside of Europe, including the
                      United States, under the following conditions:
                    </p>

                    <p>
                      Contractual Obligation: Transfers may be necessary to
                      fulfill our commitments under our Terms, such as providing
                      you with our services and customer support, as well as
                      optimizing and improving the GMGN platform.
                    </p>
                    <p>
                      Consent: If you have consented to the transfer of your
                      personal data to countries outside of Europe, we will
                      carry out these transfers accordingly. You have the right
                      to withdraw your consent at any time. Please note that if
                      we cannot transfer your personal data to these countries,
                      our services might not be available to you.
                    </p>
                    <p>
                      Under Australia law, you may have rights regarding the
                      personal information we have collected from you, including
                      the right to access, correct, or delete it in certain
                      circumstances. To exercise these rights, please contact
                      us.
                    </p>
                  </div>
                </div>
              </div>

              {/* <Sidebar /> */}
            </div>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}

export default PrivacyPolicy;
